import { ListItem, Text, UnorderedList } from "@chakra-ui/react";
import moment from "moment";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { fullNumberToString, numberToDollar } from "utils/helpers";
import NoResults from "../NoResults";
import { EventModel } from "providers/loans/event.model";

const eventNameLabels: {
  [key: string]: string;
} = {
  // submitted_loan: "Submitted by ",
  created_loan: "Created by ",
  updated_loan: "Updated by ",
  uploaded_document: "Document Uploaded by ",
  requested_funds: "Proof of funds request sent by ",
};

const revisionValueLabel = (type: string, data: any) => {
  if (type === "dropdown" || type === "text" || type === "textarea") {
    return data;
  } else if (type === "date") {
    return moment(data).format("MM/DD/YYYY");
  } else if (type === "location") {
    return data.formatted;
  } else if (type === "dollar") {
    return numberToDollar(data);
  } else if (type === "percentage") {
    return `${fullNumberToString(data as number)}%`;
  } else if (type === "radioFloatingRate") {
    return `${data.InterestRate}%`;
  }
  return `TODO: ${type}`;
};

const VersionHistoryCollapse = () => {
  const { loan } = useContext(LoanContext);
  const {
    user: {
      company: { statuses },
    },
  } = useTenant();
  const [events, setEvents] = useState<EventModel[]>([]);

  useEffect(() => {
    setEvents(loan?.events ?? []);
  }, [loan]);

  if (events.length === 0) {
    return <NoResults message="No version history yet." />;
  }

  return (
    <UnorderedList borderLeftWidth="3px" borderLeftColor="gray.50" m="0px" pl="9px">
      {events
        .sort(
          (a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        )
        .map((ev: any) => (
          <ListItem key={ev.id} fontSize="14px" mb="16px">
            <Text color="secondary">
              {eventNameLabels[ev.name]}
              {/* {ev.name === "submitted_loan" ? "Submitted by " : "Updated by "} */}
              <strong>
                {ev.user.first_name} {ev.user.last_name}
              </strong>
            </Text>
            <Text mb="8px">{moment(ev.created_at).fromNow()}</Text>
            <UnorderedList>
              {ev.revisions.map((revision: any) =>
                revision.loan_field ? (
                  <ListItem fontSize="12px" key={revision.id}>
                    <Text key={revision.id}>
                      Changed <strong>{revision.loan_field.label}</strong> from{" "}
                      <strong>
                        {revisionValueLabel(revision.loan_field.type, revision.values.old)}
                      </strong>{" "}
                      to{" "}
                      <strong>
                        {revisionValueLabel(revision.loan_field.type, revision.values.new)}
                      </strong>
                    </Text>
                  </ListItem>
                ) : (
                  <ListItem key={revision.id} fontSize="12px">
                    <Text key={revision.id}>
                      Changed <strong>Status</strong> from{" "}
                      <strong>
                        {statuses.find((status: any) => status.id === revision.values.old)?.label}
                      </strong>{" "}
                      to{" "}
                      <strong>
                        {statuses.find((status: any) => status.id === revision.values.new)?.label}
                      </strong>
                    </Text>
                  </ListItem>
                )
              )}
            </UnorderedList>
          </ListItem>
        ))}
    </UnorderedList>
  );
};

export default VersionHistoryCollapse;
